import type { FaireProductEntity } from "../../entity_types/product";

export const p_5gdbfqyx: FaireProductEntity = {
  token: "p_5gdbfqyx",
  type: "product",
  name: "Daddy Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/res/hszgttpjt/image/upload/14ed08ec2c7dd30b4557ecc6e7c96e107b280711d04398ea943aeeab3bec0e25/1535409679.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/78b910ca32ac094fbb4b0cf0ac1665913ad4bc361ede786e8c3276c5f1435414.jpeg",
    "https://cdn.faire.com/fastly/00cdb4139e11dda5b939a718b096714a7f5a70f722cce9d765226b7f2c4a8153.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/38f3e48f8d7137343300be91a090e4eaa8405b49a5549490120c6cbb1f22c432.jpeg",
    "https://cdn.faire.com/fastly/271b1ecf7b320c6edb839db5e0cf35a315a35ebfdf6eee0c119b106997f286b5.jpeg",
    "https://cdn.faire.com/fastly/98ded03a535aa646ab2d97bc0f96ed2b78f45d422a5b0a60ce97fcf64997eae3.jpeg"
  ],
  priceDollars: 6.75,
  description: "Anyone can be DADDY! Why fuss with diapers, messes, and tantrums, when you can just buy the socks? Can be paired with other clothes, or just a cigar and an overconfident smirk. DADDY’s choice!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:52.345Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
